import { RapportageElementType } from "./rapportage-samenstellen-types";

export enum RapportageElementSoort {
  Onderdeel = "Onderdeel",
  Hoofdstuk = "Hoofdstuk",
  Koptekst = "Koptekst",
  Tekstblok = "Tekstblok",
  Grafiek = "Grafiek",
  Tabel = "Tabel",
  Iteratie = "Iteratie",
  GegenereerdeTekst = "GegenereerdeTekst"
}

export const defaultElementen: RapportageElementType[] = [
  {
    code: 1,
    naam: "Voorblad",
    naamWeergevenAlsTitel: true,
    inhoudBeschikbaar: true,
    geselecteerd: false,
    soortElement: RapportageElementSoort.Onderdeel,
    volgnummer: 1,
    elementen: [],
    inhoud: null,
    perAdviesAanpasbaar: null,
    kolommen: [],
    gebruikAi: null,
    promptNaam: null,
    promptAanvulling: null
  },
  {
    code: 2,
    naam: "Inhoudsopgave",
    naamWeergevenAlsTitel: true,
    inhoudBeschikbaar: true,
    geselecteerd: true,
    soortElement: RapportageElementSoort.Onderdeel,
    volgnummer: 2,
    elementen: [],
    inhoud: null,
    perAdviesAanpasbaar: null,
    kolommen: [],
    gebruikAi: null,
    promptNaam: null,
    promptAanvulling: null
  },
  {
    code: 3,
    naam: "Hoofdstukken",
    naamWeergevenAlsTitel: true,
    inhoudBeschikbaar: true,
    geselecteerd: true,
    soortElement: RapportageElementSoort.Onderdeel,
    volgnummer: 3,
    elementen: [
      {
        code: 301,
        naam: "Inleiding",
        naamWeergevenAlsTitel: true,
        inhoudBeschikbaar: true,
        geselecteerd: true,
        soortElement: RapportageElementSoort.Hoofdstuk,
        volgnummer: 1,
        elementen: [],
        inhoud: null,
        perAdviesAanpasbaar: null,
        kolommen: [],
        gebruikAi: null,
        promptNaam: null,
        promptAanvulling: null
      },
      {
        code: 302,
        naam: "Uw huidige situatie",
        naamWeergevenAlsTitel: true,
        inhoudBeschikbaar: true,
        geselecteerd: false,
        soortElement: RapportageElementSoort.Hoofdstuk,
        volgnummer: 1,
        elementen: [
          {
            code: 30201,
            naam: "Belangrijke financiïele gebeurtenissen",
            naamWeergevenAlsTitel: true,
            inhoudBeschikbaar: true,
            geselecteerd: true,
            soortElement: RapportageElementSoort.Hoofdstuk,
            volgnummer: 1,
            elementen: [],
            inhoud: null,
            perAdviesAanpasbaar: null,
            kolommen: [],
            gebruikAi: null,
            promptNaam: null,
            promptAanvulling: null
          },
          {
            code: 30202,
            naam: "Uw gegevens",
            naamWeergevenAlsTitel: true,
            inhoudBeschikbaar: true,
            geselecteerd: true,
            soortElement: RapportageElementSoort.Hoofdstuk,
            volgnummer: 2,
            elementen: [],
            inhoud: null,
            perAdviesAanpasbaar: null,
            kolommen: [],
            gebruikAi: null,
            promptNaam: null,
            promptAanvulling: null
          },
          {
            code: 30203,
            naam: "Uw huidige lastenoverzicht",
            naamWeergevenAlsTitel: true,
            inhoudBeschikbaar: true,
            geselecteerd: true,
            soortElement: RapportageElementSoort.Hoofdstuk,
            volgnummer: 3,
            elementen: [],
            inhoud: null,
            perAdviesAanpasbaar: null,
            kolommen: [],
            gebruikAi: null,
            promptNaam: null,
            promptAanvulling: null
          },
          {
            code: 30204,
            naam: "Analyse van uw financiïele risico's",
            naamWeergevenAlsTitel: true,
            inhoudBeschikbaar: true,
            geselecteerd: true,
            soortElement: RapportageElementSoort.Hoofdstuk,
            volgnummer: 4,
            elementen: [],
            inhoud: null,
            perAdviesAanpasbaar: null,
            kolommen: [],
            gebruikAi: null,
            promptNaam: null,
            promptAanvulling: null
          },
          {
            code: 30205,
            naam: "Uw huidige netto besteedbaar inkomen",
            naamWeergevenAlsTitel: true,
            inhoudBeschikbaar: true,
            geselecteerd: true,
            soortElement: RapportageElementSoort.Hoofdstuk,
            volgnummer: 5,
            elementen: [],
            inhoud: null,
            perAdviesAanpasbaar: null,
            kolommen: [],
            gebruikAi: null,
            promptNaam: null,
            promptAanvulling: null
          },
          {
            code: 30206,
            naam: "Ontwikkeling van uw vermogen",
            naamWeergevenAlsTitel: true,
            inhoudBeschikbaar: true,
            geselecteerd: true,
            soortElement: RapportageElementSoort.Hoofdstuk,
            volgnummer: 6,
            elementen: [],
            inhoud: null,
            perAdviesAanpasbaar: null,
            kolommen: [],
            gebruikAi: null,
            promptNaam: null,
            promptAanvulling: null
          }
        ],
        inhoud: null,
        perAdviesAanpasbaar: null,
        kolommen: [],
        gebruikAi: null,
        promptNaam: null,
        promptAanvulling: null
      },
      {
        code: 303,
        naam: "Uw wensen en doelstellingen",
        naamWeergevenAlsTitel: true,
        inhoudBeschikbaar: true,
        geselecteerd: true,
        soortElement: RapportageElementSoort.Hoofdstuk,
        volgnummer: 1,
        elementen: [
          {
            code: 30301,
            naam: "Aanleiding",
            naamWeergevenAlsTitel: true,
            inhoudBeschikbaar: true,
            geselecteerd: true,
            soortElement: RapportageElementSoort.Hoofdstuk,
            volgnummer: 1,
            elementen: [],
            inhoud: null,
            perAdviesAanpasbaar: null,
            kolommen: [],
            gebruikAi: null,
            promptNaam: null,
            promptAanvulling: null
          },
          {
            code: 30302,
            naam: "Dienstverlening",
            naamWeergevenAlsTitel: true,
            inhoudBeschikbaar: true,
            geselecteerd: true,
            soortElement: RapportageElementSoort.Hoofdstuk,
            volgnummer: 2,
            elementen: [],
            inhoud: null,
            perAdviesAanpasbaar: null,
            kolommen: [],
            gebruikAi: null,
            promptNaam: null,
            promptAanvulling: null
          }
        ],
        inhoud: null,
        perAdviesAanpasbaar: null,
        kolommen: [],
        gebruikAi: null,
        promptNaam: null,
        promptAanvulling: null
      },
      {
        code: 304,
        naam: "Uw benodigde financiering",
        naamWeergevenAlsTitel: true,
        inhoudBeschikbaar: true,
        geselecteerd: false,
        soortElement: RapportageElementSoort.Hoofdstuk,
        volgnummer: 1,
        elementen: [
          {
            code: 30401,
            naam: "Financieringsopzet",
            naamWeergevenAlsTitel: true,
            inhoudBeschikbaar: true,
            geselecteerd: true,
            soortElement: RapportageElementSoort.Hoofdstuk,
            volgnummer: 1,
            elementen: [],
            inhoud: null,
            perAdviesAanpasbaar: null,
            kolommen: [],
            gebruikAi: null,
            promptNaam: null,
            promptAanvulling: null
          },
          {
            code: 30402,
            naam: "Overwaardespecificatie",
            naamWeergevenAlsTitel: true,
            inhoudBeschikbaar: true,
            geselecteerd: true,
            soortElement: RapportageElementSoort.Hoofdstuk,
            volgnummer: 2,
            elementen: [],
            inhoud: null,
            perAdviesAanpasbaar: null,
            kolommen: [],
            gebruikAi: null,
            promptNaam: null,
            promptAanvulling: null
          },
          {
            code: 30403,
            naam: "Restschuldspecificatie",
            naamWeergevenAlsTitel: true,
            inhoudBeschikbaar: true,
            geselecteerd: true,
            soortElement: RapportageElementSoort.Hoofdstuk,
            volgnummer: 3,
            elementen: [],
            inhoud: null,
            perAdviesAanpasbaar: null,
            kolommen: [],
            gebruikAi: null,
            promptNaam: null,
            promptAanvulling: null
          },
          {
            code: 30404,
            naam: "Verbouwingsspecificatie",
            naamWeergevenAlsTitel: true,
            inhoudBeschikbaar: true,
            geselecteerd: true,
            soortElement: RapportageElementSoort.Hoofdstuk,
            volgnummer: 4,
            elementen: [],
            inhoud: null,
            perAdviesAanpasbaar: null,
            kolommen: [],
            gebruikAi: null,
            promptNaam: null,
            promptAanvulling: null
          },
          {
            code: 30405,
            naam: "Fiscale aftrek van de financiering",
            naamWeergevenAlsTitel: true,
            inhoudBeschikbaar: true,
            geselecteerd: true,
            soortElement: RapportageElementSoort.Hoofdstuk,
            volgnummer: 5,
            elementen: [],
            inhoud: null,
            perAdviesAanpasbaar: null,
            kolommen: [],
            gebruikAi: null,
            promptNaam: null,
            promptAanvulling: null
          },
          {
            code: 30406,
            naam: "Oversluitenindicatie",
            naamWeergevenAlsTitel: true,
            inhoudBeschikbaar: true,
            geselecteerd: true,
            soortElement: RapportageElementSoort.Hoofdstuk,
            volgnummer: 6,
            elementen: [],
            inhoud: null,
            perAdviesAanpasbaar: null,
            kolommen: [],
            gebruikAi: null,
            promptNaam: null,
            promptAanvulling: null
          }
        ],
        inhoud: null,
        perAdviesAanpasbaar: null,
        kolommen: [],
        gebruikAi: null,
        promptNaam: null,
        promptAanvulling: null
      },
      {
        code: 305,
        naam: "Ons advies",
        naamWeergevenAlsTitel: true,
        inhoudBeschikbaar: true,
        geselecteerd: true,
        soortElement: RapportageElementSoort.Hoofdstuk,
        volgnummer: 1,
        elementen: [
          {
            code: 30501,
            naam: "Belangrijke financiïele gebeurtenissen",
            naamWeergevenAlsTitel: true,
            inhoudBeschikbaar: true,
            geselecteerd: true,
            soortElement: RapportageElementSoort.Hoofdstuk,
            volgnummer: 1,
            elementen: [],
            inhoud: null,
            perAdviesAanpasbaar: null,
            kolommen: [],
            gebruikAi: null,
            promptNaam: null,
            promptAanvulling: null
          },
          {
            code: 30502,
            naam: "Adviessamenvatting",
            naamWeergevenAlsTitel: true,
            inhoudBeschikbaar: true,
            geselecteerd: true,
            soortElement: RapportageElementSoort.Hoofdstuk,
            volgnummer: 2,
            elementen: [],
            inhoud: null,
            perAdviesAanpasbaar: null,
            kolommen: [],
            gebruikAi: null,
            promptNaam: null,
            promptAanvulling: null
          },
          {
            code: 30503,
            naam: "Samenvatting van ons advies",
            naamWeergevenAlsTitel: true,
            inhoudBeschikbaar: true,
            geselecteerd: true,
            soortElement: RapportageElementSoort.Hoofdstuk,
            volgnummer: 3,
            elementen: [],
            inhoud: null,
            perAdviesAanpasbaar: null,
            kolommen: [],
            gebruikAi: null,
            promptNaam: null,
            promptAanvulling: null
          },
          {
            code: 30504,
            naam: "Uw financiïele risico's",
            naamWeergevenAlsTitel: true,
            inhoudBeschikbaar: true,
            geselecteerd: true,
            soortElement: RapportageElementSoort.Hoofdstuk,
            volgnummer: 4,
            elementen: [],
            inhoud: null,
            perAdviesAanpasbaar: null,
            kolommen: [],
            gebruikAi: null,
            promptNaam: null,
            promptAanvulling: null
          },
          {
            code: 30505,
            naam: "Overzicht geadviseerde producten",
            naamWeergevenAlsTitel: true,
            inhoudBeschikbaar: true,
            geselecteerd: true,
            soortElement: RapportageElementSoort.Hoofdstuk,
            volgnummer: 5,
            elementen: [],
            inhoud: null,
            perAdviesAanpasbaar: null,
            kolommen: [],
            gebruikAi: null,
            promptNaam: null,
            promptAanvulling: null
          },
          {
            code: 30506,
            naam: "Geadviseerde producten",
            naamWeergevenAlsTitel: true,
            inhoudBeschikbaar: true,
            geselecteerd: true,
            soortElement: RapportageElementSoort.Hoofdstuk,
            volgnummer: 6,
            elementen: [],
            inhoud: null,
            perAdviesAanpasbaar: null,
            kolommen: [],
            gebruikAi: null,
            promptNaam: null,
            promptAanvulling: null
          },
          {
            code: 30507,
            naam: "Overzicht van uw nieuwe lasten",
            naamWeergevenAlsTitel: true,
            inhoudBeschikbaar: true,
            geselecteerd: true,
            soortElement: RapportageElementSoort.Hoofdstuk,
            volgnummer: 7,
            elementen: [],
            inhoud: null,
            perAdviesAanpasbaar: null,
            kolommen: [],
            gebruikAi: null,
            promptNaam: null,
            promptAanvulling: null
          },
          {
            code: 30508,
            naam: "Uw nieuwe netto besteedbaar inkomen",
            naamWeergevenAlsTitel: true,
            inhoudBeschikbaar: true,
            geselecteerd: true,
            soortElement: RapportageElementSoort.Hoofdstuk,
            volgnummer: 8,
            elementen: [],
            inhoud: null,
            perAdviesAanpasbaar: null,
            kolommen: [],
            gebruikAi: null,
            promptNaam: null,
            promptAanvulling: null
          },
          {
            code: 30509,
            naam: "Ontwikkeling van uw vermogen",
            naamWeergevenAlsTitel: true,
            inhoudBeschikbaar: true,
            geselecteerd: true,
            soortElement: RapportageElementSoort.Hoofdstuk,
            volgnummer: 9,
            elementen: [],
            inhoud: null,
            perAdviesAanpasbaar: null,
            kolommen: [],
            gebruikAi: null,
            promptNaam: null,
            promptAanvulling: null
          },
          {
            code: 30510,
            naam: "Overzicht vergeleken voorstellen",
            naamWeergevenAlsTitel: true,
            inhoudBeschikbaar: true,
            geselecteerd: true,
            soortElement: RapportageElementSoort.Hoofdstuk,
            volgnummer: 10,
            elementen: [],
            inhoud: null,
            perAdviesAanpasbaar: null,
            kolommen: [],
            gebruikAi: null,
            promptNaam: null,
            promptAanvulling: null
          }
        ],
        inhoud: null,
        perAdviesAanpasbaar: null,
        kolommen: [],
        gebruikAi: null,
        promptNaam: null,
        promptAanvulling: null
      },
      {
        code: 306,
        naam: "Toelichting bij ons advies",
        naamWeergevenAlsTitel: true,
        inhoudBeschikbaar: true,
        geselecteerd: true,
        soortElement: RapportageElementSoort.Hoofdstuk,
        volgnummer: 1,
        elementen: [
          {
            code: 30601,
            naam: "Algemeen",
            naamWeergevenAlsTitel: true,
            inhoudBeschikbaar: true,
            geselecteerd: true,
            soortElement: RapportageElementSoort.Hoofdstuk,
            volgnummer: 1,
            elementen: [],
            inhoud: null,
            perAdviesAanpasbaar: null,
            kolommen: [],
            gebruikAi: null,
            promptNaam: null,
            promptAanvulling: null
          },
          {
            code: 30602,
            naam: "Uw hypotheek",
            naamWeergevenAlsTitel: true,
            inhoudBeschikbaar: true,
            geselecteerd: true,
            soortElement: RapportageElementSoort.Hoofdstuk,
            volgnummer: 2,
            elementen: [],
            inhoud: null,
            perAdviesAanpasbaar: null,
            kolommen: [],
            gebruikAi: null,
            promptNaam: null,
            promptAanvulling: null
          },
          {
            code: 30603,
            naam: "Wat gebeurt er bij overlijden?",
            naamWeergevenAlsTitel: true,
            inhoudBeschikbaar: true,
            geselecteerd: true,
            soortElement: RapportageElementSoort.Hoofdstuk,
            volgnummer: 3,
            elementen: [],
            inhoud: null,
            perAdviesAanpasbaar: null,
            kolommen: [],
            gebruikAi: null,
            promptNaam: null,
            promptAanvulling: null
          },
          {
            code: 30604,
            naam: "Wat gebeurt er bij arbeidsongeschiktheid?",
            naamWeergevenAlsTitel: true,
            inhoudBeschikbaar: true,
            geselecteerd: true,
            soortElement: RapportageElementSoort.Hoofdstuk,
            volgnummer: 4,
            elementen: [],
            inhoud: null,
            perAdviesAanpasbaar: null,
            kolommen: [],
            gebruikAi: null,
            promptNaam: null,
            promptAanvulling: null
          },
          {
            code: 30605,
            naam: "Wat gebeurt er bij werkloosheid?",
            naamWeergevenAlsTitel: true,
            inhoudBeschikbaar: true,
            geselecteerd: true,
            soortElement: RapportageElementSoort.Hoofdstuk,
            volgnummer: 5,
            elementen: [],
            inhoud: null,
            perAdviesAanpasbaar: null,
            kolommen: [],
            gebruikAi: null,
            promptNaam: null,
            promptAanvulling: null
          },
          {
            code: 30606,
            naam: "Hoe ziet uw pensioen eruit?",
            naamWeergevenAlsTitel: true,
            inhoudBeschikbaar: true,
            geselecteerd: true,
            soortElement: RapportageElementSoort.Hoofdstuk,
            volgnummer: 6,
            elementen: [],
            inhoud: null,
            perAdviesAanpasbaar: null,
            kolommen: [],
            gebruikAi: null,
            promptNaam: null,
            promptAanvulling: null
          },
          {
            code: 30607,
            naam: "Uw vermogensopbouw",
            naamWeergevenAlsTitel: true,
            inhoudBeschikbaar: true,
            geselecteerd: true,
            soortElement: RapportageElementSoort.Hoofdstuk,
            volgnummer: 7,
            elementen: [],
            inhoud: null,
            perAdviesAanpasbaar: null,
            kolommen: [],
            gebruikAi: null,
            promptNaam: null,
            promptAanvulling: null
          },
          {
            code: 30608,
            naam: "Uw consumptieve kredieten",
            naamWeergevenAlsTitel: true,
            inhoudBeschikbaar: true,
            geselecteerd: true,
            soortElement: RapportageElementSoort.Hoofdstuk,
            volgnummer: 8,
            elementen: [],
            inhoud: null,
            perAdviesAanpasbaar: null,
            kolommen: [],
            gebruikAi: null,
            promptNaam: null,
            promptAanvulling: null
          }
        ],
        inhoud: null,
        perAdviesAanpasbaar: null,
        kolommen: [],
        gebruikAi: null,
        promptNaam: null,
        promptAanvulling: null
      },
      {
        code: 307,
        naam: "Akkoordverklaring",
        naamWeergevenAlsTitel: true,
        inhoudBeschikbaar: true,
        geselecteerd: true,
        soortElement: RapportageElementSoort.Hoofdstuk,
        volgnummer: 1,
        elementen: [],
        inhoud: null,
        perAdviesAanpasbaar: null,
        kolommen: [],
        gebruikAi: null,
        promptNaam: null,
        promptAanvulling: null
      }
    ],
    inhoud: null,
    perAdviesAanpasbaar: null,
    kolommen: [],
    gebruikAi: null,
    promptNaam: null,
    promptAanvulling: null
  },
  {
    code: 4,
    naam: "Bijlagen",
    naamWeergevenAlsTitel: true,
    inhoudBeschikbaar: true,
    geselecteerd: false,
    soortElement: RapportageElementSoort.Onderdeel,
    volgnummer: 4,
    elementen: [
      {
        code: 401,
        naam: "Specificatie van uw inkomen en uitgaven ",
        naamWeergevenAlsTitel: true,
        inhoudBeschikbaar: true,
        geselecteerd: true,
        soortElement: RapportageElementSoort.Hoofdstuk,
        volgnummer: 1,
        elementen: [],
        inhoud: null,
        perAdviesAanpasbaar: null,
        kolommen: [],
        gebruikAi: null,
        promptNaam: null,
        promptAanvulling: null
      },
      {
        code: 402,
        naam: "Specificatie van uw vermogen",
        naamWeergevenAlsTitel: true,
        inhoudBeschikbaar: true,
        geselecteerd: true,
        soortElement: RapportageElementSoort.Hoofdstuk,
        volgnummer: 2,
        elementen: [],
        inhoud: null,
        perAdviesAanpasbaar: null,
        kolommen: [],
        gebruikAi: null,
        promptNaam: null,
        promptAanvulling: null
      },
      {
        code: 403,
        naam: "Specificatie van uw belastbaar inkomen",
        naamWeergevenAlsTitel: true,
        inhoudBeschikbaar: true,
        geselecteerd: true,
        soortElement: RapportageElementSoort.Hoofdstuk,
        volgnummer: 3,
        elementen: [],
        inhoud: null,
        perAdviesAanpasbaar: null,
        kolommen: [],
        gebruikAi: null,
        promptNaam: null,
        promptAanvulling: null
      },
      {
        code: 404,
        naam: "Overzicht van de hypotheekvormen",
        naamWeergevenAlsTitel: true,
        inhoudBeschikbaar: true,
        geselecteerd: true,
        soortElement: RapportageElementSoort.Hoofdstuk,
        volgnummer: 4,
        elementen: [],
        inhoud: null,
        perAdviesAanpasbaar: null,
        kolommen: [],
        gebruikAi: null,
        promptNaam: null,
        promptAanvulling: null
      },
      {
        code: 405,
        naam: "Toelichting op pensioen",
        naamWeergevenAlsTitel: true,
        inhoudBeschikbaar: true,
        geselecteerd: true,
        soortElement: RapportageElementSoort.Hoofdstuk,
        volgnummer: 5,
        elementen: [],
        inhoud: null,
        perAdviesAanpasbaar: null,
        kolommen: [],
        gebruikAi: null,
        promptNaam: null,
        promptAanvulling: null
      },
      {
        code: 406,
        naam: "Toelichting op sociale voorzieningen",
        naamWeergevenAlsTitel: true,
        inhoudBeschikbaar: true,
        geselecteerd: true,
        soortElement: RapportageElementSoort.Hoofdstuk,
        volgnummer: 6,
        elementen: [],
        inhoud: null,
        perAdviesAanpasbaar: null,
        kolommen: [],
        gebruikAi: null,
        promptNaam: null,
        promptAanvulling: null
      },
      {
        code: 407,
        naam: "De uitgereikte documenten",
        naamWeergevenAlsTitel: true,
        inhoudBeschikbaar: true,
        geselecteerd: true,
        soortElement: RapportageElementSoort.Hoofdstuk,
        volgnummer: 7,
        elementen: [],
        inhoud: null,
        perAdviesAanpasbaar: null,
        kolommen: [],
        gebruikAi: null,
        promptNaam: null,
        promptAanvulling: null
      },
      {
        code: 408,
        naam: "Te ontvangen documenten",
        naamWeergevenAlsTitel: true,
        inhoudBeschikbaar: true,
        geselecteerd: true,
        soortElement: RapportageElementSoort.Hoofdstuk,
        volgnummer: 8,
        elementen: [],
        inhoud: null,
        perAdviesAanpasbaar: null,
        kolommen: [],
        gebruikAi: null,
        promptNaam: null,
        promptAanvulling: null
      },
      {
        code: 409,
        naam: "Uw klantprofiel",
        naamWeergevenAlsTitel: true,
        inhoudBeschikbaar: true,
        geselecteerd: true,
        soortElement: RapportageElementSoort.Hoofdstuk,
        volgnummer: 9,
        elementen: [],
        inhoud: null,
        perAdviesAanpasbaar: null,
        kolommen: [],
        gebruikAi: null,
        promptNaam: null,
        promptAanvulling: null
      },
      {
        code: 410,
        naam: "Wijzigingsverklaring",
        naamWeergevenAlsTitel: true,
        inhoudBeschikbaar: true,
        geselecteerd: true,
        soortElement: RapportageElementSoort.Hoofdstuk,
        volgnummer: 10,
        elementen: [],
        inhoud: null,
        perAdviesAanpasbaar: null,
        kolommen: [],
        gebruikAi: null,
        promptNaam: null,
        promptAanvulling: null
      },
      {
        code: 411,
        naam: "Disclaimer",
        naamWeergevenAlsTitel: true,
        inhoudBeschikbaar: true,
        geselecteerd: true,
        soortElement: RapportageElementSoort.Hoofdstuk,
        volgnummer: 11,
        elementen: [],
        inhoud: null,
        perAdviesAanpasbaar: null,
        kolommen: [],
        gebruikAi: null,
        promptNaam: null,
        promptAanvulling: null
      }
    ],
    inhoud: null,
    perAdviesAanpasbaar: null,
    kolommen: [],
    gebruikAi: null,
    promptNaam: null,
    promptAanvulling: null
  }
];
